import React from 'react';
import { Link } from 'react-router-dom';
import { ASSET_BASE_URL } from '../config/constants';

function Terms() {
  return (
    <div style={{
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    }}>
      {/* Header */}
      <header style={{
        padding: '24px',
        borderBottom: '1px solid #eee'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none'
          }}>
            <img
              src={`${ASSET_BASE_URL}/favicon.jpg`}
              alt="Bonzai"
              style={{ width: '32px', height: '32px', borderRadius: '6px' }}
            />
            <span style={{ fontSize: '20px', fontWeight: '600', color: '#333' }}>bonzai</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '700px',
        margin: '0 auto',
        padding: '48px 24px'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '700',
          color: '#333',
          marginBottom: '32px'
        }}>
          Terms of Service
        </h1>

        <p style={{ color: '#666', marginBottom: '24px', fontSize: '14px' }}>
          Last updated: January 2025
        </p>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Acceptance of Terms
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            By using Bonzai, you agree to these Terms of Service. If you do not agree, please do not use our service.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Description of Service
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            Bonzai is a code visualization tool that runs on your local machine. When you run our CLI tool, it starts a local server that reads your project's file structure to generate interactive visualizations in your browser.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Local Processing
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            Bonzai operates entirely on your local machine. The tool connects to a local server running on your computer to read and visualize your project files. Your source code is not transmitted to any external servers.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Use of Analytics
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            Our website uses Google Analytics to collect anonymous usage statistics. This helps us understand how our website is used and improve our service.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Disclaimer of Warranties
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            Bonzai is provided "as is" without warranty of any kind. We do not guarantee that the service will be error-free or uninterrupted.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Limitation of Liability
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            To the maximum extent permitted by law, Bonzai shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Changes to Terms
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            We may update these Terms of Service from time to time. Continued use of the service after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Contact
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7' }}>
            If you have any questions about these Terms of Service, please contact us at <a href="mailto:sanjog@bonzai.dev" style={{ color: '#3B82F6' }}>sanjog@bonzai.dev</a>.
          </p>
        </section>
      </main>
    </div>
  );
}

export default Terms;
